import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Ready to Experience AI Evolution?
        </h2>
        <p className="text-xl text-slate-300 mb-8">
          Join the revolution in software development. Your projects start evolving today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 rounded-xl text-lg font-semibold shadow-xl transition-all duration-200 transform hover:scale-105">
            Start Your Free Evolution
            <ArrowRight className="h-5 w-5 ml-2 inline" />
          </button>
          <button className="border border-slate-600 hover:border-slate-500 text-white px-8 py-4 rounded-xl text-lg font-semibold transition-all duration-200 hover:bg-slate-800">
            Schedule Enterprise Demo
          </button>
        </div>
        
        <div className="mt-12 bg-gradient-to-r from-blue-900/20 to-purple-900/20 border border-blue-500/20 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-white mb-4">🚀 Revolutionary Difference</h3>
          <p className="text-slate-300 leading-relaxed">
            Unlike traditional development tools or generic AI assistants, HiveCluster provides autonomous software evolution 
            through corporate-structured AI meetings. Your projects improve while you sleep, guided by specialized agents 
            that understand both technical implementation and business strategy.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
